import { type ListPrice, type RetailPrice } from '../../../algolia'

/*
  This function checks the "price" object of type Retail or List price that is coming from the "prices" object from an Algolia Record.
  The reason we use this "price" object and not rely directly on an already existing property at the root of Algolia Record object is that it has more data and is the source of truth for the prices.
 */
export const productSearchAlgoliaAccessorIsPricePresent = (
  price: RetailPrice | ListPrice | undefined,
): boolean => {
  if (!price) {
    return false
  }

  return price.amount > 0
}
